// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"a2402db5","214":"7be280f4","886":"b905db92","933":"84d0d97d"}[chunkId] + ".chunk.css";
};